
import { defineComponent, watch, reactive, computed, onMounted, ref } from 'vue';
import { userStore } from '@/store/user-store';
import { calendarStore } from '@/store/calendar-store';
import { Form as ValidationForm } from 'vee-validate';
import Message from 'primevue/message';

// eslint-disable-next-line
//@ts-ignore
import FormControlInput from '@/components/general/FormControl/Input';
// eslint-disable-next-line
//@ts-ignore
import FormControlTextarea from '@/components/general/FormControl/TextArea';
// eslint-disable-next-line
//@ts-ignore
import FormControlSlider from '@/components/general/FormControl/Slider';
import { AttendanceForm, CalendarConfigInterface, MessageInterface } from '@/models/calendar.model';

export default defineComponent({
  name: 'Attendance',
  components: {
    ValidationForm,
    FormControlInput,
    FormControlTextarea,
    FormControlSlider,
    Message,
  },
  setup() {
    const form = reactive({
      name: '',
      email: '',
      comment: '',
      countAttendees: null,
    });

    const showAttendance = ref<boolean>(false);
    const showForm = ref<boolean>(true);
    //computed
    const isLoading = computed((): boolean => {
      return calendarStore.getState().isLoadingContent;
    });
    const attendanceMessage = computed((): MessageInterface | null | undefined => {
      return calendarStore.getState().attendanceMessage;
    });
    const messages = computed((): MessageInterface[] | null => {
      if (attendanceMessage.value) {
        return [
          {
            severity: attendanceMessage.value.severity,
            content: attendanceMessage.value.content,
          },
        ];
      } else return [];
    });
    const calendarConfig = computed((): CalendarConfigInterface => {
      return calendarStore.getState().calendarConfig;
    });
    const isAttendand = computed((): number | undefined => {
      return calendarStore.getState().singleEvent.attendanceid;
    });

    //methods:
    const onProcessForm = (values: AttendanceForm) => {
      calendarStore
        .processForm(values)
        .then(() => {
          showForm.value = false;
        })
        .catch((error: any) => {
          console.log(error.response);
        });
    };
    const resetMessage = () => {
      if (attendanceMessage.value?.content === 'Sie haben sich für diesen Termin bereits angemeldet') {
        showAttendance.value = !showAttendance.value;
      }
      calendarStore.setAttendanceMessage(null);
    };
    //lifehooks
    onMounted(() => {
      if (userStore.getState().user) {
        form.name = userStore.getState().user!.internal_name;
        form.email = userStore.getState().user!.email;
        calendarStore.getSelfAttendance();
      }
    });
    watch(userStore.getState(), () => {
      // if user is logged in, attendance fields get filled, if he already submitted attendance, he gets response
      if (userStore.getState().user) {
        form.name = userStore.getState().user!.internal_name;
        form.email = userStore.getState().user!.email;
        calendarStore.getSelfAttendance();
      } else {
        form.name = '';
        (form.email = ''), calendarStore.setAttendanceMessage(null);
      }
    });

    // //close attendanceForm on event-change
    watch(
      () => calendarStore.getState().singleEvent,
      (oV, nV) => {
        calendarStore.getSelfAttendance();
        if (oV.id !== nV.id) {
          showAttendance.value = false;
        }
      },
      { deep: true }
    );

    return {
      form,
      attendanceMessage,
      onProcessForm,
      calendarConfig,
      messages,
      showAttendance,
      isLoading,
      isAttendand,
      showForm,
      resetMessage,
    };
  },
});
